
/**
 * Internal dependencies
 */
import {
    COUPONS_RECEIVE,
    COUPONS_REQUEST,
    COUPONS_REQUEST_SUCCESS,
    COUPONS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllCoupons, requestingCoupons } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestCoupons = (page = 1, limit = 10) => (dispatch) => {
    dispatch({
        type: COUPONS_REQUEST
    });
    return cscom.coupon().list()
        .then(coupons => {
            dispatch({
                type: COUPONS_REQUEST_SUCCESS,
            });
            dispatch({
                type: COUPONS_RECEIVE,
                payload: {
                    items: coupons
                }
            });
            return coupons
        }).catch((error) => {
            dispatch({
                type: COUPONS_REQUEST_FAILURE,
                error,
            });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCouponsIfNotRequested = (...props) => async (dispatch, getState) => {

    const coupons = getAllCoupons(getState());
    const requesting = requestingCoupons(getState());

    if (coupons.length == 0 && requesting == false) {
        return dispatch(requestCoupons(...props))
    }

    return coupons;
}